import R from 'app/assets/R'
import {
  SvgAttendanceRecordFocusIcon,
  SvgAttendanceRecordIcon,
  SvgCompanyFocusIcon,
  SvgCompanyIcon,
  SvgDashboardFocusIcon,
  SvgDashboardIcon,
  SvgHumanResourcesIcon,
  SvgInventoryManagementFocusIcon,
  SvgMailBoxFocusIcon,
  SvgMailBoxIcon,
  SvgMarketingFocusIcon,
  SvgMarketingIcon,
  SvgWorkScheduleFocusIcon,
  SvgWorkScheduleIcon,
} from 'app/assets/svg-assets'
import { PermissionEnum } from 'app/common/enum'
import {
  ACCOUNT_MANAGEMENT_PATH,
  ACTIVITY_ENGAGEMENT_MANAGEMENT_PATH,
  APPROVE_UNION_MEMBERS_PATH,
  CHINH_SACH_PHAP_LUAT_HO_TRO_CHUYEN_MON_PATH,
  CONG_TAC_NU_CONG_PATH,
  DASHBOARD_PATH,
  DEGREE_MANAGEMENT_PATH,
  EVENT_MANAGEMENT_PATH,
  FANPAGE_CONG_DOAN,
  HRM_TRADE_UNION_MEMBER_MANAGEMENT_PATH,
  LINK_THU_MUC_ANH_CLIP_SU_KIEN,
  LUAT_DIEU_LE_CONG_DOAN_PATH,
  NEW_MEMBER_DECLARATION,
  NEW_UEH_PATH,
  REGISTER_ACTIVITY_PATH,
  ROLE_MANAGEMENT_PATH,
  SCHOOL_MANAGEMENT_PATH,
  THI_DUA_KHEN_THUONG_PATH,
  TIN_TIEU_DIEM_PATH,
  TRADE_UNION_MEMBER_MANAGEMENT_PATH,
  TUM_YOUR_UNIT_MANAGEMENT_PATH,
  TUYEN_GIAO_VAN_THE_PATH,
  UNIT_MANAGEMENT_PATH,
  VAN_BAN_BIEU_MAU_PATH
} from 'app/components/router/route-path'
import React from 'react'

export interface SidebarNavigationItem {
  title: string
  key: string
  url?: string
  children?: SidebarNavigationItem[]
  icon?: React.ReactNode
  iconFocus?: React.ReactNode
  permission?: PermissionEnum
  isLink?: boolean
  isNeedInUnit?: boolean
}

export const sidebarNavigation: SidebarNavigationItem[] = [
  {
    title: R.strings.dashboard,
    key: R.strings.dashboard,
    url: DASHBOARD_PATH,
    icon: <SvgDashboardIcon />,
    iconFocus: <SvgDashboardFocusIcon />,
    children: undefined,
  },
  {
    title: 'Ban Chấp hành Công đoàn',
    key: 'Ban Chấp hành Công đoàn',
    isLink: true,
    url: 'https://congdoan.ueh.edu.vn/ban-chap-hanh-cong-doan-ueh/',
    icon: <SvgDashboardIcon opacity={0} />,
    iconFocus: <SvgDashboardIcon opacity={0} />,
  },
  {
    title: 'QL Đoàn viên công đoàn',
    key: R.strings.trade_union_member,
    icon: <SvgHumanResourcesIcon />,
    iconFocus: <SvgInventoryManagementFocusIcon />,
    children: [
      {
        title: R.strings.account_management,
        key: R.strings.account_management,
        url: ACCOUNT_MANAGEMENT_PATH,
        permission: PermissionEnum.ReadAccount,
      },
      {
        title: R.strings.role_management,
        key: R.strings.role_management,
        url: ROLE_MANAGEMENT_PATH,
        permission: PermissionEnum.ReadRole,
      },
      {
        title: 'Đoàn viên công đoàn',
        key: R.strings.trade_union_members_management,
        url: TRADE_UNION_MEMBER_MANAGEMENT_PATH,
        permission: PermissionEnum.ReadTradeUnionMember,
      },
      {
        title: 'Đoàn viên đơn vị của bạn',
        key: TUM_YOUR_UNIT_MANAGEMENT_PATH,
        url: TUM_YOUR_UNIT_MANAGEMENT_PATH,
        permission: PermissionEnum.ReadTradeUnionMemberInYourUnit,
        isNeedInUnit: true,
      },
      {
        title: 'Dữ liệu từ HRM',
        key: R.strings.hrm_trade_union_members_management,
        url: HRM_TRADE_UNION_MEMBER_MANAGEMENT_PATH,
        permission: PermissionEnum.ReadTumHrm,
      },
      {
        title: 'Khai báo đoàn viên',
        key: R.strings.new_member_declaration,
        url: NEW_MEMBER_DECLARATION,
        permission: PermissionEnum.CreateNewTumRegister,
      },
      {
        title: 'Phê duyệt Đoàn viên',
        key: R.strings.approve_union_members,
        url: APPROVE_UNION_MEMBERS_PATH,
        permission: PermissionEnum.ReadNewTumRegister,
      },
      {
        title: R.strings.activity_engagement_management,
        key: R.strings.activity_engagement_management,
        url: ACTIVITY_ENGAGEMENT_MANAGEMENT_PATH,
        permission: PermissionEnum.ReadActivityEngagement,
      },
      {
        title: R.strings.degree_management,
        key: R.strings.degree_management,
        url: DEGREE_MANAGEMENT_PATH,
        permission: PermissionEnum.ReadDegree,
      },
    ],
  },
  {
    title: R.strings.event_management,
    key: R.strings.event_management,
    url: EVENT_MANAGEMENT_PATH,
    icon: <SvgWorkScheduleIcon />,
    iconFocus: <SvgWorkScheduleFocusIcon />,
    permission: PermissionEnum.ReadEvent,
    children: undefined,
  },
  {
    title: R.strings.unit_management,
    key: R.strings.unit_management,
    url: UNIT_MANAGEMENT_PATH,
    icon: <SvgCompanyIcon />,
    iconFocus: <SvgCompanyFocusIcon />,
    permission: PermissionEnum.ReadUnit,
  },
  {
    title: R.strings.school_management,
    key: R.strings.school_management,
    url: SCHOOL_MANAGEMENT_PATH,
    icon: <SvgMarketingIcon />,
    iconFocus: <SvgMarketingFocusIcon />,
    permission: PermissionEnum.ReadSchool,
  },
  {
    title: R.strings.register_join_activity,
    key: R.strings.register_join_activity,
    url: REGISTER_ACTIVITY_PATH,
    icon: <SvgAttendanceRecordIcon />,
    iconFocus: <SvgAttendanceRecordFocusIcon />,
    children: undefined,
  },
  {
    title: R.strings.news_union,
    key: R.strings.news_union,
    icon: <SvgMailBoxIcon />,
    iconFocus: <SvgMailBoxFocusIcon />,
    children: [
      {
        title: 'Website Công đoàn UEH',
        key: 'Website Công đoàn UEH',
        url: NEW_UEH_PATH,
        isLink: true,
      },
      {
        title: 'Tin tiêu điểm',
        key: 'Tin tiêu điểm',
        url: TIN_TIEU_DIEM_PATH,
        isLink: true,
      },
      {
        title: 'Công tác nữ công',
        key: 'Công tác nữ công',
        url: CONG_TAC_NU_CONG_PATH,
        isLink: true,
      },
      {
        title: 'Tuyển giao vận thể',
        key: 'Tuyển giao vận thể',
        url: TUYEN_GIAO_VAN_THE_PATH,
        isLink: true,
      },
      {
        title: 'Luật điều lệ công đoàn',
        key: 'Luật điều lệ công đoàn',
        url: LUAT_DIEU_LE_CONG_DOAN_PATH,
        isLink: true,
      },
      {
        title: 'Thi đua khen thưởng',
        key: 'Thi đua khen thưởng',
        url: THI_DUA_KHEN_THUONG_PATH,
        isLink: true,
      },
      {
        title: 'CS-PL-HT chuyên môn',
        key: 'CS-PL-HT chuyên môn',
        url: CHINH_SACH_PHAP_LUAT_HO_TRO_CHUYEN_MON_PATH,
        isLink: true,
      },
      {
        title: 'Văn bản biểu mẫu',
        key: 'Văn bản biểu mẫu',
        url: VAN_BAN_BIEU_MAU_PATH,
        isLink: true,
      },
      {
        title: 'Fanpage Công đoàn',
        key: 'Fanpage Công đoàn',
        url: FANPAGE_CONG_DOAN,
        isLink: true,
      },
      {
        title: 'Thư mục Ảnh/Clip sự kiện',
        key: 'Thư mục Ảnh/Clip sự kiện',
        url: LINK_THU_MUC_ANH_CLIP_SU_KIEN,
        isLink: true,
      },
    ],
  },
  // {
  //   title: R.strings.report,
  //   key: R.strings.report,
  //   url: REPORT_PATH,
  //   icon: <SvgReportIcon />,
  //   iconFocus: <SvgReportFocusIcon />,
  //   permission: PermissionEnum.ReadReport
  // },
]
